/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

export type GetLeadsByStatusStatus = typeof GetLeadsByStatusStatus[keyof typeof GetLeadsByStatusStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLeadsByStatusStatus = {
  NEW: 'NEW',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
} as const;
